<template>
  <div class="FixedButton">
    <a
      v-if="!hideCart"
      href="/shop/shopping/cart"
      @click.prevent="goCartPage"
      class="cart"
    >
      <i class="icon iconfont pdp_rightsuspension_shoppingcart vertical-middle pre">&#xe655;</i>
      <span v-if="getCount">{{ getCount }}</span>
    </a>
    <div
      v-popover:service
      class="service"
      @click="service"
    >
      <i class="icon iconfont pdp_rightsuspension_shoppingcart vertical-middle pre">&#xe653;</i>
    </div>
    <el-popover
      ref="service"
      placement="left"
      width="160"
      trigger="hover"
      popper-class="service-popover"
    >
      <p :style="{textAlign: 'center'}">
        {{TLang('在线客服','my')}}
      </p>
    </el-popover>
    <div
      v-popover:tel
      class="qrcode"
    >
      <i>
        <svg
          t="1583857313501"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3438"
          width="60"
          height="60"
        ><path
          d="M600.487 665.6C500.313 665.6 358.4 510.33 358.4 425.183c0-33.392 45.078-66.783 65.948-66.783 24.209 0 65.948 74.296 65.948 87.652 0 10.018-4.174 17.53-8.348 23.374-3.34 5.009-5.844 9.183-5.844 14.191 0.835 10.853 48.418 59.27 60.105 60.94 4.174 0 9.182-2.505 14.191-5.844 7.513-4.174 15.86-8.348 25.878-8.348 15.026 0 89.322 48.418 89.322 66.783 0 37.565-35.896 68.452-65.113 68.452zM420.469 376.234c-2.202 0.667-4.746 1.716-7.476 3.109-5.961 3.04-12.304 7.447-18.012 12.598-12.27 11.07-19.514 23.525-19.514 33.242 0 35.581 31.334 91.488 78.659 140.253 49.22 50.719 105.045 83.097 146.361 83.097 9.663 0 21.8-5.655 31.546-15.24 9.937-9.773 15.922-22.042 16.46-34.334a17.51 17.51 0 0 0-0.301-0.466c-1.289-1.927-3.48-4.469-6.437-7.394-6.128-6.061-14.945-13.19-25.006-20.275-9.56-6.73-19.663-13.006-28.186-17.537-4.066-2.162-7.612-3.839-10.36-4.916-1.12-0.439-2.035-0.749-2.685-0.925-4.476 0.165-8.902 1.821-16.267 5.875-8.047 5.281-15.19 8.302-23.042 8.302h-1.213l-1.2-0.171c-10.9-1.557-25.806-13.603-43.87-31.947-7.312-7.426-14.073-14.993-19.168-21.513-7.231-9.251-11.11-15.788-11.67-23.066l-0.05-0.653v-0.656c0-4.978 1.132-9.61 3.199-14.157 1.394-3.067 2.946-5.654 5.51-9.5l0.153-0.23 0.16-0.224c3.391-4.747 4.987-8.48 5.154-12.7-0.16-0.63-0.435-1.511-0.821-2.587-0.962-2.678-2.452-6.132-4.352-10.047-4.148-8.548-9.803-18.407-15.853-27.505-6.616-9.95-13.32-18.43-19.27-24.263-2.88-2.822-5.448-4.89-7.513-6.119-0.643-0.382-1.169-0.643-1.551-0.793-0.791 0.074-1.953 0.308-3.385 0.742z"
          fill="#333333"
          p-id="3439"
        ></path></svg>
      </i>
      <el-popover
        ref="tel"
        placement="left"
        width="160"
        trigger="hover"
        popper-class="tel-popover"
      >
        <p>{{ TLang('贴心客服热线','my') }}</p>
        <h3>{{ tel }}</h3>
        <div v-if="union == 'nyushanghai' && (df_lang && df_lang == 'en-US' || union_isBilingual)">{{ TLang('周一至周五','my') }} 09:00-18:00</div>
        <div v-else>{{ TLang('周一至周日','my') }} 09:00-21:00</div>
      </el-popover>
    </div>
    <div
      v-if='!hidenQrcode'
      v-popover:qrcode
      class="qrcode"
    >
      <i>
        <svg
          t="1583857375590"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3562"
          width="60"
          height="60"
        ><path
          d="M373.57 358.4h106.193c8.378 0 15.17 6.792 15.17 15.17v106.193c0 8.378-6.792 15.17-15.17 15.17H373.57c-8.378 0-15.17-6.792-15.17-15.17V373.57c0-8.378 6.792-15.17 15.17-15.17z m1.897 17.067v102.4h102.4v-102.4h-102.4z m-1.897 153.6h106.193c8.378 0 15.17 6.792 15.17 15.17V650.43c0 8.378-6.792 15.17-15.17 15.17H373.57c-8.378 0-15.17-6.792-15.17-15.17V544.237c0-8.378 6.792-15.17 15.17-15.17z m1.897 17.066v102.4h102.4v-102.4h-102.4z m161.28-17.066h1.706a7.68 7.68 0 0 1 7.68 7.68V657.92a7.68 7.68 0 0 1-7.68 7.68h-1.706a7.68 7.68 0 0 1-7.68-7.68V536.747a7.68 7.68 0 0 1 7.68-7.68z m59.747 51.136h1.706a7.68 7.68 0 0 1 7.68 7.68v69.974a7.68 7.68 0 0 1-7.68 7.68h-1.706a7.68 7.68 0 0 1-7.68-7.68v-69.974a7.68 7.68 0 0 1 7.68-7.68z m59.72-51.136h1.706a7.68 7.68 0 0 1 7.68 7.68V657.92a7.68 7.68 0 0 1-7.68 7.68h-1.707a7.68 7.68 0 0 1-7.68-7.68V536.747a7.68 7.68 0 0 1 7.68-7.68zM544.236 358.4H650.43c8.378 0 15.17 6.792 15.17 15.17v106.193c0 8.378-6.792 15.17-15.17 15.17H544.237c-8.378 0-15.17-6.792-15.17-15.17V373.57c0-8.378 6.792-15.17 15.17-15.17z m1.896 17.067v102.4h102.4v-102.4h-102.4z"
          fill="#333333"
          p-id="3563"
        ></path></svg>
      </i>
    </div>
    <div
      v-if="!hidenToTop"
      class="toTop"
      @click="toTop"
    >
      <i class="icon iconfont pdp_rightsuspension_shoppingcart vertical-middle pre">&#xe658;</i>
      <p>{{TLang('返回顶部','my')}}</p>
    </div>
    <el-popover
      ref="qrcode"
      placement="left"
      width="195"
      trigger="hover"
      popper-class="qrcode-popover"
    >
      <img :src="require('@assets/images/qrcode.jpg')" />
      <p>{{TLang('微信扫一扫关注东福','my')}}</p>
    </el-popover>
  </div>
</template>

<script>
import {  mapGetters } from 'vuex';
import { unionFlag, gioClickHandle } from "@utils";
import Cookies from 'js-cookie';
export default {
  name: 'FixedButton',
  props: {
    hideCart: Boolean,
    hidenQrcode: Boolean,
    hidenToTop: Boolean,
    channelName: String,
  },
  data(){
    return {
      tel: unionFlag() ? '400-618-2999' : '400-003-1010',
      df_lang: Cookies.get('df_lang'),
      union: unionFlag(),
    };
  },
  computed:{
    ...mapGetters('shopCart', ['getCount']),
  },
  methods: {
    toTop(){
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    service(){
      this.sendGio(this.TLang('在线客服', 'my'))
      try{
        window.qimoChatClick();
      }catch(err){
        console.log(err);
      }
    },
    goCartPage(){
      this.sendGio(this.TLang('购物车', 'my'))
      window.location.href = '/shop/shopping/cart'
    },
    sendGio(elementname){
      const params = {
        df_channle: this.channelName,
        df_pagename:this.TLang('频道首页', 'my'),
        df_modulename:this.TLang('快捷按钮', 'my'),
        df_elementname:elementname,
      }
      if(this.channelName){
        gioClickHandle('DF_elementClick',params,'channelGio')
      }
    }
  },
};
</script>

<style lang="less" scoped>
.FixedButton{
  position: fixed;
  right: 20px;
  bottom: 162px;
  z-index: 999;
  div, a{
    width: 60px;
    height: 60px;
    text-align: center;
    display: block;
    i{
      font-size: 40px;
      text-align: center;
    }
    &:hover{
      cursor: pointer;
    }
  }
}
.cart{
  position: relative;
  background: #ededed;
  span{
    position: absolute;
    background:rgba(255,255,255,0.95);
    border-radius:7px;
    border:1px solid rgba(255,255,255,1);
    color: #F44545;
    right: 8px;
    top: 8px;
    font-size: 10px;
    padding: 0 2px;
  }
}
.service{
  background: #ededed;
   &:hover{
      background: #3d96e2;
      i{
        color: #fff;
        // display: none;
      }
    }
}
 .qrcode-popover{
    p{
      text-align: center;
      font-size:14px;
      color: #111;
    }
  }
  .qrcode{
    background: #ededed;
    &:hover{
      background: #3d96e2;
      path{
        fill: #fff;
      }
    }
  }
  .service-popover{
    text-align: center;
  }
  .tel-popover{
    text-align: center;
    p{
      color: #999;
      font-size: 14px;
    }
    h3{
      font-size: 16px;
      color: #111;
    }
    div{
      font-size: 12px;
      color: #999;
      margin-top: 10px;
    }
  }
  .toTop{
    background: #ededed;
    &:hover{
      background: #3d96e2;
      i{
        color: #fff;
        display: none;
      }
      p{
        display: inline-block;
        white-space: wrap;
        color: #fff;
      }
    }
    p{
      display: none;
      padding: 10px;
      box-sizing: border-box;
    }
  }
</style>